const APP_DATA = {
  title: "Buy | Canuckz Holiday",
  baseUrl: "https://prod-canuk-caho.canucks-publishing.com/",
  useWhitelist: true,
  whitelistUrl: "https://prod-canuk-caho.canucks-publishing.com/",
  whitelistId: "canuckz_holiday_prelaunch",
  launchDate: "2021-12-19T16:00:00Z", //GMT TEST launch time
  policyId: "d9c89513a435cc36a4f89bc417e1805ed92945b50caa0413dd12258e",
  // preloadedProductIndex: 0 //REQUIRED ONLY FOR SINGLE PRODUCT DESIGNS
}

export default APP_DATA;